import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';

export default class ImageDropZone extends PureComponent {


  render() {
    const { image, onDrop, imagePath } = this.props;
    const hasImage = image.preview || imagePath;

    return (
      <div className="dropzone-container">
        <div className="d-flex justify-content-center align-items-center">
          <div className="product-upload__image-container">
            <Dropzone
              onDrop={(accepted, rejected) => {
                onDrop(accepted, rejected)
              }}
              className="dropzone"
            >
              {hasImage && <div className="product-upload__image-edit">
                <div className="s7-upload"></div>
              </div>}

              {hasImage
                ? <img
                  src={image.preview ? image.preview : imagePath}
                  className="product-upload__image"
                  alt="Story"
                />
                : <div>
                  <span className="btn btn-rounded btn-space btn-secondary">Upload Section Image</span>
                  <p className="text-center mb-1"><em>Recommended: 960x270px</em></p>
                  <p className="text-center mb-0"><em>white background jpg</em></p>
                </div>
              }
            </Dropzone>
          </div>
        </div>
      </div>
    )
  }
}

ImageDropZone.propTypes = {
  image: PropTypes.object, 
  onDrop: PropTypes.func,  //Required
  imagePath: PropTypes.string
}

ImageDropZone.defaultProps = {
  image: {}, 
  onDrop: () => {}, 
  imagePath: ""
};


// WEBPACK FOOTER //
// ./src/containers/Generic/ImageDropZone.js